export default __webpack_public_path__ + "static/media/Legguards of the Usurper.1f2c31fb.jpg";